import { type UserAnnouncement } from '@soulhx/fs-common';
import React, { useState } from 'react';
import { MaxLengthTextViewer } from '../../../common/ui/MaxLengthTextViewer.js';
import { StandardButton } from '@soulhx/ui-common';
import { Col, Container, Row } from 'react-bootstrap';
import { useMarkAnnouncementReadMutation } from '@soulhx/client-store';
import { useNavigate } from 'react-router-dom';

interface IAnnSnapshotItem {
  announcement: UserAnnouncement;
}
export const AnnSnapshotItem = ({ announcement }: IAnnSnapshotItem) => {
  const [textWasTrimmed, setTextWasTrimmd] = useState(false);
  const [markReadApi] = useMarkAnnouncementReadMutation();
  const navigate = useNavigate();

  return (
    <Container fluid className="bg-light-subtle">
      <Row>
        <Col xs={textWasTrimmed ? 10 : 11} className="m-0 p-0">
          <MaxLengthTextViewer
            maxLength={150}
            text={`**${announcement.title.trim()}** ` + announcement.body}
            setDidExceed={(didExceed) => setTextWasTrimmd(didExceed)}
          />
        </Col>

        {textWasTrimmed && (
          <Col xs={1} className="m-0 p-0">
            <StandardButton type="fullscreen" onClick={() => navigate(`/comms/announcement/${announcement.id}`)} />
          </Col>
        )}

        <Col xs={1} className="m-0 p-0">
          <StandardButton
            type="complete"
            done={announcement.isRead}
            onClick={async () => {
              markReadApi(announcement.id);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};
